export default __webpack_public_path__ + "static/logrhythm-d848b3c12c19b89d693cd25ca6b03240.jpg";